import { useFormContext } from 'react-hook-form'
import { useDebouncedCallback } from '@/hooks'
import { TextInput } from '@/components/atoms'

export const DeliveryLocationTypeFilters = () => {
    const { setValue, control } = useFormContext()

    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        debouncedSearch(e.target.value)
    }

    const debouncedSearch = useDebouncedCallback((value: string) => {
        setValue('filters.search', value)
        setValue('pagination.currentPage', 1)
    }, 400)

    return (
        <div className="flex items-center">
            <div className="relative w-full sm:w-64">
                <TextInput
                    control={control}
                    name="filtersForm.search"
                    label=""
                    placeholder="Search delivery areas"
                    onChange={handleSearchChange}
                    className="w-full"
                />
            </div>
        </div>
    )
}
